export const tasksListLocalization = {
  tasks: {
    en: 'Tasks',
    nb: 'Oppgaver',
    nn: 'Oppgåver',
  },
  noTasksWaiting: {
    en: 'You have no pending tasks',
    nb: 'Du har ingen oppgaver som venter',
    nn: 'Du har ingen oppgåver som ventar',
  },
  errorLoadingTasks: {
    en: 'Error loading tasks',
    nb: 'Feil ved lasting av oppgaver',
    nn: 'Feil ved lasting av oppgåver',
  },
} as const;
